// @flow

import styled from 'styled-components';
import { gridTemplateColumns, grid } from '../../../helpers/gridHelpers';
import type { Theme } from '../../../types';

const ButtonWrapper = styled<any, Theme>('div')`
  ${grid()}
  ${gridTemplateColumns('1fr auto 1fr')}
  align-items: center;
  grid-gap: 1.5rem;
  margin: 3.5rem 0.5rem 1rem;

  /* a hack to target ie only */
  @media all and (-ms-high-contrast:none) {
    display: flex;
    justify-content: center;
  }
`;

export default ButtonWrapper;
